import { ageInYears } from '~/utils/date'

export const isAgeRestricted = (dateOfBirth: string, requiredAge: string) => {
  const userAgeInYears = ageInYears(dateOfBirth)

  return userAgeInYears < parseInt(requiredAge, 10)
}
